import { normalizeStringOrNull } from '@dashboardApp/helpers/normalize';

export function buildTrendingProductIdeasRoute(categorySlug = null) {
    const normalizedCategorySlug = normalizeStringOrNull(categorySlug);

    if (!normalizedCategorySlug) {
        return {
            name: 'research-trending-product-ideas',
        };
    }

    return {
        name: 'research-trending-product-ideas',
        query: {
            category_slug: normalizedCategorySlug,
        },
    };
}

export function buildTrendingProductIdeasCategoryRoute(categorySlug = null) {
    const normalizedCategorySlug = normalizeStringOrNull(categorySlug);

    return normalizedCategorySlug
        ? buildTrendingProductIdeasRoute(normalizedCategorySlug)
        : null;
}
